import { LinkedList } from './LinkedList';
export class LRUCache {
    list;
    maxage;
    maxlength;
    constructor(options = { maxage: 0, maxlength: 5 }) {
        this.list = new LinkedList();
        const { maxage = 0, maxlength = 5 } = options;
        this.maxage = maxage;
        this.maxlength = maxlength;
    }
    get keys() {
        return this.list.map((v) => v.key).toArray();
    }
    get length() {
        return this.list.length;
    }
    add(key, item) {
        const { list, maxage, maxlength } = this;
        if (list.length >= maxlength) {
            list.removeElementAtIndex(list.length - 1);
        }
        list.add({ item, key, maxage }, 0);
    }
    get(key) {
        const { list, keys } = this;
        const idx = keys.indexOf(key);
        const ele = list.elementAtIndex(idx);
        if (ele) {
            list.removeElementAtIndex(idx);
            list.add(ele, 0);
        }
        return ele && ele.item;
    }
    has(key) {
        const { keys } = this;
        const idx = keys.indexOf(key);
        return idx > -1;
    }
}
